import React from 'react';
import { Spinner } from 'react-bootstrap';
import { STYLES } from './types';

interface TableContainerProps {
  loading: boolean;
  children: React.ReactNode;
}

/**
 * Container for tables with loading state handling
 */
const TableContainer: React.FC<TableContainerProps> = ({ loading, children }) => (
  <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
    {loading ? (
      <div className="d-flex justify-content-center align-items-center" style={STYLES.table.loadingContainer}>
        <Spinner animation="border" role="status" variant="warning">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    ) : (
      children
    )}
  </div>
);

export default React.memo(TableContainer);
